import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  SimpleChanges
} from '@angular/core';
import {ModelService} from '../Services/model.service';
import {BackgroundJob} from '../Model/Dto/BackgroundJob';
import {Message} from '../Model/System/Message';
import {JobService} from '../Services/job.service';
import {TranslateService} from '@ngx-translate/core';
import {BackgroundJobEvent} from '../Model/Dto/BackgroundJobEvent';
import {confirm, custom} from 'devextreme/ui/dialog';
import {RestartJob} from '../Model/Dto/RestartJob';
import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import {ValidateExportJob} from '../Model/Dto/ValidateExportJob';
import {TemplateService} from '../Services/template.service';
import {DxDataGridComponent} from 'devextreme-angular';
import {OAuthService} from 'angular-oauth2-oidc';
import {UserManagementService} from '../Services/userManagment.service';
import CustomStore from 'devextreme/data/custom_store';
import {MaintenanceModeService} from '../Services/MaintenanceModeService';
import {MaintenanceMode} from '../Model/Dto/MaintenanceMode';
import {DateFilter} from '../Model/ui/DateFilter';
import {ColumnCellTemplateData} from 'devextreme/ui/data_grid';
import {UserSettingsService} from 'app/Services/userSettings.service';
import {SignalrService} from "../Services/signalr.service";
import {auditTime, filter, Subscription} from "rxjs";
import DevExpress from "devextreme";
import RowCollapsedEvent = DevExpress.ui.dxDataGrid.RowCollapsedEvent;

@Component({
  selector: 'job-list',
  templateUrl: './jobList.component.html',
  styleUrls: ['./jobList.component.css']
})
export class JobListComponent implements OnInit, OnDestroy {
  rowExpanedEmitter = new EventEmitter<number>();
  rowCollapsedEmmiter = new EventEmitter<number>();
  @ViewChild(DxDataGridComponent, {static: true}) dataGrid: DxDataGridComponent;
  @Input() jobListMode: boolean = true;
  @Input() catalogMode: boolean = false;
  @Input() adminMode: boolean = false;
  @Input() visible = false;
  @Input() storeName: string = 'JobListStateNewUI_V5';
  maintenanceModeActive: boolean = false;
  filterValue: Array<any>;
  startRefresherFirstTime: boolean = true;
  itemCount: any;
  dateFilterValue: number;
  dateFilterDataSource: DateFilter[];
  dataSource: CustomStore<any, any>;
  hasActiveState = false;
  pinJobId: number = -1;
  pinJobIsPinned: boolean = false;
  pinJobRemarks: string = '';
  pinJobPinExpires?: Date = null;
  currentSignalRGroup: string = '';
  private jobUpdateSub?: Subscription;
  private jobCreatedSub?: Subscription;
  constructor(
    public modelService: ModelService,
    public templateService: TemplateService,
    public translate: TranslateService,
    public authService: OAuthService,
    public userManagementService: UserManagementService,
    public maintenanceModeService: MaintenanceModeService,
    public userSettingsService: UserSettingsService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef,
    private signalRService: SignalrService
  ) {
    this.onExpandAll = this.onExpandAll.bind(this);
    this.onCollapseAll = this.onCollapseAll.bind(this);
    this.translateType = this.translateType.bind(this);
    this.onDetailInitialized = this.onDetailInitialized.bind(this);
    this.isVisible = this.isVisible.bind(this);
    this.startRefreshing = this.startRefreshing.bind(this);

    this.dateFilterDataSource = new Array<DateFilter>();
    this.dateFilterDataSource.push(new DateFilter('Heute', 0));
    this.dateFilterDataSource.push(new DateFilter('Letzten 7 Tage', -6));
    this.dateFilterDataSource.push(new DateFilter('Letzten 30 Tage', -29));
    this.dateFilterDataSource.push(new DateFilter('Alle', 1));
    this.dateFilterValue = this.dateFilterDataSource[1].dayDelta;
  }

  get isAdmin() {
    return this.modelService.loginService.isAdmin;
  }

  _pindataVisible: boolean = false;

  get pindataVisible(): boolean {
    return this._pindataVisible;
  }

  set pindataVisible(value: boolean) {
    if (!value) {
      this.pinJobId = -1;
      this.pinJobIsPinned = false;
      this.pinJobRemarks = '';
      this.pinJobPinExpires = null;
    }
    this._pindataVisible = value;
  }

  ngOnInit(): void {
    if (this.isAdmin) {
      this.getCurrentState();
    }

    if (this.catalogMode) {
      this.setCatalogModeDataSource();
    }
    if (this.adminMode) {
      this.setAdminModeDataSource();
    }
    if (this.jobListMode) {
      this.setJobListModeDataSource();
    }

    this.dataSource.totalCount(null).then((count) => (this.itemCount = count));
  }

  ngOnDestroy(): void {
    this.jobListMode = false;
    this.catalogMode = false;
    this.adminMode = false;
    this.jobUpdateSub?.unsubscribe();
    this.jobCreatedSub?.unsubscribe();
    var signalRGroupString = "";
    if (this.adminMode) {
      signalRGroupString = "JOBS_ALL";
    } else {
      signalRGroupString = this.modelService.loginService.currentCustomer.id.toString();
    }
    this.signalRService.removeJobUpdate(signalRGroupString);

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes["visible"]) return;
    if (this.visible) {
      queueMicrotask(() => this.startRefreshing());
    }
  }

  setAdminModeDataSource() {
    var accessToken = this.authService.getAccessToken();
    this.dataSource = AspNetData.createStore({
      key: 'id',
      loadUrl: 'api/job/GetJobsForAdminMode',
      loadParams: {dateDelta: this.dateFilterValue},
      onBeforeSend(method, ajaxOptions) {
        (ajaxOptions.xhrFields = {withCredentials: true}),
          (ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          });
      },
      onLoaded: (data) => this.handleErrorState(data)
    });
  }

  setCatalogModeDataSource() {
    var catalogId = this.modelService.catalogService.selectedCatalogId;
    var accessToken = this.authService.getAccessToken();
    this.dataSource = AspNetData.createStore({
      key: 'id',
      loadUrl: 'api/job/GetJobsForCatalogMode',
      loadParams: {catalogId: catalogId, customerId: this.modelService.loginService.currentCustomer.id},
      onBeforeSend(method, ajaxOptions) {
        (ajaxOptions.xhrFields = {withCredentials: true}),
          (ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          });
      },
      onLoaded: (data) => this.handleErrorState(data)
    });
  }

  setJobListModeDataSource() {
    var accessToken = this.authService.getAccessToken();
    this.dataSource = AspNetData.createStore({
      key: 'id',
      loadUrl: 'api/job/GetJobsForJobListMode',
      onBeforeSend(method, ajaxOptions) {
        (ajaxOptions.xhrFields = {withCredentials: true}),
          (ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          });
      },
      onLoaded: (data) => this.handleErrorState(data)
    });
  }

  onExpandAll() {
    this.dataGrid.instance.expandAll();
  }

  onCollapseAll() {
    this.dataGrid.instance.collapseAll();
  }

  onDateFilterValueChanged() {
    this.setAdminModeDataSource();
    this.dataGrid?.instance?.refresh();
  }

  public translateType(cellInfo) {
    if (!cellInfo.value) return undefined;
    var result = this.translate.instant(cellInfo.value);
    return result;
  }

  async startRefresher() {

    if (this.startRefresherFirstTime) {
      this.startRefresherFirstTime = false;
      this.loadGridState();
      this.dataGrid.instance.option('loadPanel.enabled', false);
      this.dataGrid.instance.clearFilter();
      var signalRGroupString: string = "";

      if (this.adminMode) {
        signalRGroupString = "JOBS_ALL";
      } else if (this.catalogMode) {
        signalRGroupString = this.modelService.catalogService.selectedCatalogId;
      } else {
        signalRGroupString = this.modelService.loginService.currentCustomer.id.toString();
      }


      this.currentSignalRGroup = signalRGroupString;

      this.startRefreshing();
      await this.signalRService.startJobUpdateFeed(signalRGroupString);
      this.jobUpdateSub = this.signalRService.jobUpdateSubject$.pipe(
        filter(e => e.CustomerId === this.currentSignalRGroup || this.adminMode),
        auditTime(2000)
      ).subscribe(e => {
        this.startRefreshing();
      });


      this.jobCreatedSub = this.signalRService.jobCreatedUpdateSubject$.pipe(
        filter(e => e.CustomerId === this.currentSignalRGroup || this.adminMode)
      ).subscribe(e => {
        this.startRefreshing();
      });
    }
  }

  startRefreshing(forceRefresh: boolean = false) {
    if (!forceRefresh) {
      if (this.isVisible()) {
        if (this.isAdmin) {
          this.getCurrentState();
        }
        this.dataGrid.instance.refresh(true);
      }
    } else {
      this.dataGrid.instance.refresh(true);
    }
  }

  isVisible() {
    return (
      (this.jobListMode && this.modelService.viewService.jobsVisible) ||
      (this.catalogMode && this.modelService.viewService.catalogJobsVisible) ||
      this.adminMode
    );
  }

  applyFilterUser() {
    const grid = this.dataGrid.instance;
    grid.clearFilter();

    const user = this.modelService.loginService.currentUser;
    const query = (user.lastName && user.firstName) ? `${user.lastName}, ${user.firstName}` : user.email;

    this.filterValue = [['userName', '=', query]];
    this.hasActiveState = true;

    const state = grid.state?.() ?? {};
    grid.state(state);
  }

  applyFilterPinned() {
    const grid = this.dataGrid.instance;
    grid.clearFilter();

    this.filterValue = [['isPinned', '=', true]];
    this.hasActiveState = true;

    const state = grid.state?.() ?? {};
    grid.state(state);
  }

  async applyFilterReset() {
    const grid = this.dataGrid.instance;

    grid.clearGrouping();
    await grid.refresh(true);

    grid.clearFilter();
    grid.clearSorting();
    grid.option('searchPanel.text', '');
    this.filterValue = undefined;

    try {
      const userId = this.modelService.loginService.currentUser.id;
      await this.userSettingsService.saveGridState({userId, stateJson: null});
    } catch {
    }

    grid.state(null);

    grid.columnOption('created', {sortIndex: 0, sortOrder: 'desc'});

    this.setHasActiveStateImmediate(false);
  }

  jobService() {
    return this.modelService.jobService;
  }

  time(started, ended) {
    var time = (Date.parse(ended) - Date.parse(started)) / 1000;
    if (time < 600) {
      const text = this.translate.instant('Sekunden');
      return Math.floor(time * 10) / 10 + ' ' + text;
    }
    const text = this.translate.instant('Minuten');
    time = time / 60;
    return Math.floor(time) + ' ' + text;
  }

  getCatalogNameById(id: string): string {
    const cat = this.modelService.catalogService.catalogs.filter((catalog) => catalog.id == id).shift();
    if (cat) {
      return cat.catalogName;
    }
    return '';
  }

  isValidatable(job: BackgroundJob): boolean {
    if (!job.resultFile) return false;

    return job.type === 'Export' && job.state === 2 && job.resultFile.endsWith('.zip');
  }

  onEditClicked(catalog: BackgroundJob) {
    if (catalog.resultCatalogId) {
      this.modelService.catalogService.selectedCatalogId = catalog.resultCatalogId;
    } else {
      this.modelService.catalogService.selectedCatalogId = catalog.catalogId;
    }
    if (this.modelService.router.url == '/catalog') {
      this.modelService.router.navigate(['/catalogdetails']);
    } else {
      this.modelService.router.navigate([
        '/catalog/' +
        this.modelService.loginService.currentCustomer.id +
        '/' +
        this.modelService.catalogService.selectedCatalogId
      ]);
    }
  }

  userCanEdit() {
    return this.userManagementService.canEdit('jobListDelete');
  }

  onAdminDeleteClicked(e) {
    this.modelService.jobService.delete(e.id);
  }

  async onCancelClicked(e: { id: any }) {
    let message, title;
    message = this.translate.instant('Wollen Sie den Job wirklich abbrechen');
    title = this.translate.instant('Job abbrechen');
    const result = await confirm(message, title);
    if (!result) return;
    await this.modelService.jobService.cancelJob(e.id);
    this.modelService.systemService.notify(
      new Message(this.translate.instant('Der Job wird, sobald es möglich ist, abgebrochen'))
    );
  }

  async onDeleteClicked(e: { id: any }) {
    let message, title;
    message = this.translate.instant('Wollen Sie den Job wirklich löschen');
    title = this.translate.instant('Job löschen');
    const result = await confirm(message, title);
    if (!result) return;
    const res = (await this.modelService.jobService.setIsDeleted(e.id)).value;
    if (res != '0:0') {
      this.showWarningForDeleteResult(res);
    } else {
      this.modelService.systemService.notify(new Message(this.translate.instant('Jobs erfolgreich gelöscht')));
    }
  }

  deleteReadyJobs() {
    let txtYes = '';
    let txtNo = '';
    let txtMsg = '';
    let txtTitle = '';
    let myDialog: any;

    this.translate.get('Ja').subscribe((text: string) => {
      txtYes = text;
    });
    this.translate.get('Nein').subscribe((text: string) => {
      txtNo = text;
    });
    this.translate.get('Sollen wirklich alle beendeten Jobs gelöscht werden?').subscribe((text: string) => {
      txtMsg = text;
    });
    this.translate.get('Wirklich löschen?').subscribe((text: string) => {
      txtTitle = text;
    });
    myDialog = custom({
      title: txtTitle,
      messageHtml: txtMsg,
      buttons: [
        {
          text: txtYes,
          onClick: (e) => {
            return {buttonText: true};
          }
        },
        {
          text: txtNo,
          onClick: (e) => {
            return {buttonText: false};
          }
        }
      ]
    });
    myDialog.show().then((dialogResult) => {
      if (dialogResult.buttonText == true) {
        this.modelService.jobService
          .setIsDeletedForFinishedJobs(this.modelService.loginService.currentUser.customerId)
          .subscribe((res: any) => {
            const result = res.value;
            if (result != '0:0') {
              this.showWarningForDeleteResult(result);
            } else {
              this.translate.get('Jobs erfolgreich gelöscht').subscribe((text: string) => {
                this.modelService.systemService.notify(new Message(text));
              });
            }
          });
      }
    });
  }

  deleteSelectedJobs(selectedRowsData: Array<BackgroundJob>) {
    let txtYes = '';
    let txtNo = '';
    let txtMsg = '';
    let txtTitle = '';
    let myDialog: any;

    this.translate.get('Ja').subscribe((text: string) => {
      txtYes = text;
    });
    this.translate.get('Nein').subscribe((text: string) => {
      txtNo = text;
    });
    this.translate.get('Sollen wirklich alle gewählten Jobs gelöscht werden').subscribe((text: string) => {
      txtMsg = text;
    });
    this.translate.get('Wirklich löschen?').subscribe((text: string) => {
      txtTitle = text;
    });
    myDialog = custom({
      title: txtTitle,
      messageHtml: txtMsg,
      buttons: [
        {
          text: txtYes,
          onClick: (e) => {
            return {buttonText: true};
          }
        },
        {
          text: txtNo,
          onClick: (e) => {
            return {buttonText: false};
          }
        }
      ]
    });
    myDialog.show().then((dialogResult) => {
      if (dialogResult.buttonText == true) {
        const jobIds: Array<number> = [];
        selectedRowsData.forEach((e) => jobIds.push(e.id));

        this.modelService.jobService.setIsDeletedForSelectedJobs(jobIds).subscribe((res: any) => {
          const result = res.value;
          if (result != '0:0') {
            this.showWarningForDeleteResult(result);
          } else {
            this.translate.get('Jobs erfolgreich gelöscht').subscribe((text: string) => {
              this.modelService.systemService.notify(new Message(text));
            });
          }
        });
      }
    });
  }

  showWarningForDeleteResult(result: string) {
    const values = result.split(':');

    let text = this.translate.instant('Einige Jobs konnten nicht gelöscht werden.');
    if (values[0] != '0') {
      const textPinned = this.translate.instant('Verhindert da angeheftet');
      text += '\n' + textPinned + ': ' + values[0];
    }
    if (values[1] != '0') {
      const textStatus = this.translate.instant('Verhindert durch Status');
      text += '\n' + textStatus + ': ' + values[1];
    }

    const message = new Message(text, 'warning');

    this.modelService.systemService.notify(message, 3000);
  }

  startDownload(source: string) {
    window.open(source, '_self', 'location=yes');
  }

  sendMail(source: string) {
    const subject = 'Angeforderte Produktdaten';
    const linkUrl = source;

    const body = `Sehr geehrte Damen und Herren,\n\nSie können die angeforderten Produktdaten unter folgender Adresse herunterladen:\n\n${linkUrl}`;

    const mailtoUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoUrl;
  }

  showImportTemplate(data) {
    this.templateService.importTemplateEditorVisible = true;
    this.templateService.importJob = data.data;
  }

  getIconClass(icon) {
    return JobService.getIconClass(icon);
  }

  restartJob(data: BackgroundJob) {
    const dto = new RestartJob();
    dto.jobId = data.id;
    this.modelService.jobService.restartJob(dto).subscribe((success) => {
      if (success) {
        const i = 1;
      }
    });
  }

  showPindata(data: BackgroundJob) {
    this.pinJobId = data.id;
    this.pinJobIsPinned = data.isPinned;
    this.pinJobRemarks = data.remarks;
    this.pinJobPinExpires = this.addDays(new Date(), 7);
    if (data.pinExpires) {
      this.pinJobPinExpires = data.pinExpires;
    }

    this.pindataVisible = true;
  }

  pinJob(e) {
    const id = this.pinJobId;
    const remarks = e.remarks;
    let pinExpires = e.pinExpires;

    // Aus unerklärlichen Gründen liefert die Date Box meistens string...?
    if (Object.prototype.toString.call(pinExpires) === '[object String]') {
      pinExpires = new Date(pinExpires);
    }

    this.modelService.jobService.setIsPinned(id, remarks, pinExpires).subscribe();

    this.pindataVisible = false;
  }

  unpinJob(e) {
    const id = this.pinJobId;

    this.modelService.jobService.setIsNotPinned(id).subscribe();

    this.pindataVisible = false;
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  validateExport(data: BackgroundJob) {
    const dto = new ValidateExportJob();
    dto.customerId = this.modelService.loginService.currentUser.customerId;
    dto.jobId = data.id;
    this.modelService.jobService.validateExportJob(dto).subscribe((success) => {
      if (success) {
        const i = 1;
      }
    });
  }

  getEventMessage(e: BackgroundJobEvent) {
    let result = '';
    if (e.parameter) {
      const param = JSON.parse(e.parameter);
      result = this.translate.instant(e.message, param);
    } else {
      result = this.translate.instant(e.message);
    }
    return result;
  }

  onDetailInitialized(e) {
    this.dataGrid.instance.updateDimensions();
  }

  showEventList(cellData: ColumnCellTemplateData<BackgroundJob>) {
    if (cellData.component.isRowExpanded(cellData.row.key)) {
      cellData.component.collapseRow(cellData.row.key);
    } else {
      cellData.component.expandRow(cellData.row.key);
    }
  }

  getCurrentState() {
    this.maintenanceModeService.getCurrentState().subscribe((result: MaintenanceMode) => {
      this.maintenanceModeActive = result.active;
    });
  }

  enableMaintenanceMode() {
    this.maintenanceModeService.enableMaintenanceMode().subscribe((result: MaintenanceMode) => {
      this.maintenanceModeActive = result.active;
    });
  }

  disableMaintenanceMode() {
    this.maintenanceModeService.disableMaintenanceMode().subscribe((result: MaintenanceMode) => {
      this.maintenanceModeActive = result.active;
    });
  }

  getDisplayValue(data: any): string {
    if (data.catalogName !== null && data.catalogName !== '') {
      return data.catalogName;
    } else if (data.resultCatalogName !== null && data.resultCatalogName !== '') {
      return data.resultCatalogName;
    } else {
      return '';
    }
  }

  loadGridState = async () => {
    try {
      const dto = await this.userSettingsService.getGridState();
      const has = dto && dto.stateJson !== undefined && dto.stateJson !== null && dto.stateJson !== 'null';
      const state = has ? JSON.parse(dto.stateJson) : null;

      if (state?.columns?.some((c: any) => typeof c?.groupIndex === 'number' && c.groupIndex >= 0)) {
        await new Promise((r) => setTimeout(r, 50));
      }

      this.hasActiveState = this.computeHasActiveState(state);
      return state;
    } catch (err) {
      console.error("Fehler beim Laden des GridStates", err);
      this.hasActiveState = false;
      return null;
    }
  }

  saveGridState = async (state: any) => {
    this.setHasActiveStateImmediate(this.computeHasActiveState(state));
    try {
      const userId = this.modelService.loginService.currentUser.id;
      const stateJson = state ? JSON.stringify(state) : null;
      await this.userSettingsService.saveGridState({
        userId: userId,
        stateJson
      });
    } catch (err) {
      console.error("Fehler beim Speichern des GridStates", err);
    }
  }

  onGridOptionChanged(e: any) {
    const affects =
      e.fullName === 'filterValue' ||
      e.fullName === 'searchPanel.text' ||
      (typeof e.fullName === 'string' && e.fullName.startsWith('columns')) ||
      ['filterValue', 'filterValues', 'selectedFilterOperation', 'sortIndex', 'sortOrder', 'groupIndex']
        .includes(e.name);

    if (!affects) return;

    const filterValue = (e.fullName === 'filterValue') ? e.value : e.component.option('filterValue');
    const searchText = (e.fullName === 'searchPanel.text') ? e.value : (e.component.option('searchPanel')?.text ?? '');
    const columns = e.component.option('columns') ?? [];

    let active = false;
    if (filterValue && filterValue.length) active = true;
    if (searchText) active = true;

    if (!active) {
      for (const c of columns) {
        if (!c) continue;
        if (c.filterValues?.length) {
          active = true;
          break;
        }
        const hasFilterValue = c.filterValue !== undefined && c.filterValue !== null && c.filterValue !== '';
        if (hasFilterValue) {
          active = true;
          break;
        }
        if (typeof c.groupIndex === 'number' && c.groupIndex >= 0) {
          active = true;
          break;
        }
      }
    }

    if (!active) {
      const sorted = columns
        .filter((c: any) => typeof c?.sortIndex === 'number' && c.sortIndex >= 0)
        .sort((a: any, b: any) => a.sortIndex - b.sortIndex);
      if (sorted.length) {
        const isDefaultSort =
          sorted.length === 1 &&
          sorted[0]?.dataField === 'created' &&
          (sorted[0]?.sortOrder === 'desc' || sorted[0]?.sortOrder === undefined) &&
          sorted[0]?.sortIndex === 0;
        active = !isDefaultSort;
      }
    }

    this.setHasActiveStateImmediate(active);
  }

  // Setzt den aktiven Zustand sofort und erzwingt eine UI-Aktualisierung innerhalb der Angular-Zone

  public onJobRowCollapsed(e: RowCollapsedEvent) {

    this.rowCollapsedEmmiter.emit(e.key); // e.key == JobID
  }

  public onJobRowExpanded(e: RowCollapsedEvent) {

    this.rowExpanedEmitter.emit(e.key); // e.key == JobID

  }

  private handleErrorState(items: BackgroundJob[]) {
    for (const item of items) {
      if (item.stateText === 'Error') {
        item.progress = 33;
      }
    }
  }

  // Dies ist notwendig, um sicherzustellen, dass Angular die Änderung erkennt und das Template neu rendert - direkt rendert
  private setHasActiveStateImmediate(v: boolean) {
    this.ngZone.run(() => {
      this.hasActiveState = v;
      this.cdr.detectChanges();
    });
  }

  private computeHasActiveState(state: any): boolean {
    if (!state) return false;

    if (state.filterValue && state.filterValue.length) return true;
    if (state.searchPanel?.text) return true;

    const cols = state.columns ?? [];

    for (const c of cols) {
      if (!c) continue;
      if (c.filterValues?.length) return true;
      const hasFilterValue =
        c.filterValue !== undefined && c.filterValue !== null && c.filterValue !== '';
      if (hasFilterValue) return true;
    }

    for (const c of cols) {
      if (typeof c?.groupIndex === 'number' && c.groupIndex >= 0) return true;
    }

    const sortedCols = cols
      .filter((c: any) => typeof c?.sortIndex === 'number' && c.sortIndex >= 0)
      .sort((a: any, b: any) => a.sortIndex - b.sortIndex);

    if (sortedCols.length === 0) return false;

    const isDefaultSort =
      sortedCols.length === 1 &&
      sortedCols[0]?.dataField === 'created' &&
      (sortedCols[0]?.sortOrder === 'desc' || sortedCols[0]?.sortOrder === undefined) &&
      sortedCols[0]?.sortIndex === 0;

    return !isDefaultSort;
  }
}
